import React, { useEffect, useRef, useState } from "react";
import "../styles/statsBanner.css";

function useCountUp(target, duration = 1600, startWhenVisible = true) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!startWhenVisible) return;

    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !startedRef.current) {
            startedRef.current = true;
            animate();
          }
        });
      },
      { threshold: 0.3 }
    );

    obs.observe(el);
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const animate = () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setValue(target);
      return;
    }

    const start = performance.now();
    const from = 0;
    const to = target;

    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      setValue(Math.floor(from + (to - from) * eased));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  return [value, ref];
}

export default function StatsBanner({
  bg = "var(--stats-bg, #171717)",
  text = "#FAFAFA",
  accent = "var(--brand-yellow, #FDAC21)",
  stats = [
    { label: "kiszállás", value: 500, suffix: "+" },
    { label: "elégedett vevő", value: 500, suffix: "+" },
    { label: "év tapasztalat", value: 3, suffix: "" },
  ],
  caption = "Gyors segítség, megbízható szakemberek.",
}) {
  return (
    <section
      className="stats-banner"
      style={{ background: bg, color: text }}
      role="region"
      aria-label="Számokban"
      id="aboutus"
    >
      <div className="stats-overlay" aria-hidden="true" />
      <div className="stats-inner">
        <ul className="stats-grid">
          {stats.map((s, i) => (
            <Stat
              key={i}
              label={s.label}
              value={s.value}
              suffix={s.suffix}
              accent={accent}
            />
          ))}
        </ul>
        {caption && <p className="stats-caption">{caption}</p>}
      </div>
    </section>
  );
}

function Stat({ label, value, suffix = "", accent }) {
  const [val, ref] = useCountUp(value, 1600);
  return (
    <li className="stat-item" ref={ref}>
      <span className="stat-value" style={{ color: accent }}>
        {val}
        {suffix}
      </span>
      <span className="stat-label">{label}</span>
    </li>
  );
}
